import edit from './edit';

export default { edit };
